/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { SortableHandle as sortableHandle } from 'react-sortable-hoc';

import { DragHandleIcon } from '@coursera/cds-icons';

type Props = React.SVGAttributes<SVGElement>;

export const DragHandle = sortableHandle<Props>((props: {}) => (
  <DragHandleIcon
    color="interactive"
    css={css`
      cursor: grab;
    `}
    {...props}
  />
));
